import React from 'react';
import { Artifact } from './types';
function ScreenshotPreview() {
  return <div className="w-full h-full bg-[#0d1117] flex flex-col" data-id="element-206">
      <div className="bg-[#1e2430] px-3 py-1.5 flex items-center gap-1.5" data-id="element-207">
        <div className="w-2 h-2 rounded-full bg-[#ff5f57]" data-id="element-208" />
        <div className="w-2 h-2 rounded-full bg-[#febc2e]" data-id="element-209" />
        <div className="w-2 h-2 rounded-full bg-[#28c840]" data-id="element-210" />
        <div className="ml-2 flex-1 bg-[#0d1117] rounded px-2 py-0.5 text-[10px] text-[#8a8680]" data-id="element-211">staging.zenbot.chat/dashboard</div>
      </div>
      <div className="flex-1 p-3 flex flex-col gap-1.5" data-id="element-212">
        <div className="h-2 bg-[#1e2430] rounded w-3/5" data-id="element-213" />
        <div className="h-10 bg-[#1e2430] rounded" data-id="element-214" />
        <div className="flex-1 grid grid-cols-3 gap-1.5" data-id="element-215">
          <div className="bg-[#1e2430] rounded" data-id="element-216" />
          <div className="bg-[#1e2430] rounded" data-id="element-217" />
          <div className="bg-[#1e2430] rounded" data-id="element-218" />
        </div>
      </div>
    </div>;
}
function VideoPreview() {
  return <div className="w-full h-full bg-[#0a0a0e] flex items-center justify-center relative" data-id="element-219">
      <div className="w-12 h-12 rounded-full bg-white/15 flex items-center justify-center" data-id="element-220">
        <div className="w-0 h-0 border-t-[10px] border-t-transparent border-b-[10px] border-b-transparent border-l-[18px] border-l-white/80 ml-1" data-id="element-221" />
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-6 bg-black/50 flex items-center px-2.5 gap-2" data-id="element-222">
        <span className="text-[10px] text-[#8a8680]" data-id="element-223">0:42</span>
        <div className="flex-1 h-[3px] bg-[#333] rounded relative" data-id="element-224"><div className="w-[35%] h-full bg-[#4a9a9a] rounded" data-id="element-225" /></div>
        <span className="text-[10px] text-[#8a8680]" data-id="element-226">2:01</span>
      </div>
    </div>;
}
function PreviewUrlPreview() {
  return <div className="w-full h-full bg-white flex flex-col" data-id="element-227">
      <div className="bg-[#f0f0f0] px-2.5 py-1 flex items-center gap-1.5 border-b border-[#ddd]" data-id="element-228">
        <div className="w-1.5 h-1.5 rounded-full bg-[#ccc]" data-id="element-229" />
        <div className="flex-1 bg-white rounded px-2 py-0.5 text-[10px] text-[#666]" data-id="element-230">preview-pr42.zenbot.chat</div>
      </div>
      <div className="flex-1 p-4" data-id="element-231">
        <div className="text-[16px] font-semibold text-[#1a1a1a] mb-2" data-id="element-232">Welcome to ZenBot</div>
        <div className="text-[11px] text-[#666] leading-relaxed" data-id="element-233">Your AI assistant is ready. Connect your tools, configure your preferences, and start talking.</div>
        <div className="inline-block mt-2.5 bg-[#4a9a9a] text-white px-3.5 py-1 rounded text-[11px]" data-id="element-234">Get Started</div>
      </div>
    </div>;
}
function EmailDraftPreview() {
  return <div className="w-full h-full bg-[#1a1a20] p-4" data-id="element-235">
      <div className="flex gap-2 py-1 text-[11px] border-b border-white/[0.03]" data-id="element-236"><span className="text-[#8a8680] w-12 shrink-0" data-id="element-237">To</span><span className="text-[#e8e4df]" data-id="element-238">joe@acme.com</span></div>
      <div className="flex gap-2 py-1 text-[11px] border-b border-white/[0.03]" data-id="element-239"><span className="text-[#8a8680] w-12 shrink-0" data-id="element-240">Subject</span><span className="text-[#e8e4df]" data-id="element-241">Re: Thursday meeting</span></div>
      <div className="mt-3 text-[12px] text-[#c4bfb8] leading-relaxed" data-id="element-242">Hi Joe,<br data-id="element-243" /><br data-id="element-244" />Confirming we're on for Thursday at 2pm. Same room as last week \u2014 I'll bring the updated roadmap deck.<br data-id="element-245" /><br data-id="element-246" />See you then,<br data-id="element-247" />Matt</div>
    </div>;
}
function DocumentPreview() {
  return <div className="w-full h-full bg-[#1a1a20] p-4 text-[11px] leading-relaxed" data-id="element-248">
      <div className="text-[14px] font-semibold text-[#e8e4df] mb-1.5" data-id="element-249">Rate Limiting Proposal</div>
      <div className="text-[#8a8680]" data-id="element-250">Token-bucket approach for the /sync endpoint to resolve third-party 429 errors during peak hours.</div>
      <div className="text-[12px] font-medium text-[#e8e4df] mt-2.5 mb-1" data-id="element-251">Approach</div>
      <div className="text-[#8a8680] pl-3" data-id="element-252">\u2022 100 req/min per API key</div>
      <div className="text-[#8a8680] pl-3" data-id="element-253">\u2022 10-request burst allowance</div>
      <div className="text-[#8a8680] pl-3" data-id="element-254">\u2022 Gateway-level enforcement</div>
      <div className="text-[12px] font-medium text-[#e8e4df] mt-2.5 mb-1" data-id="element-255">Timeline</div>
      <div className="text-[#8a8680]" data-id="element-256">PR by 3pm today. Staging deploy by EOD.</div>
    </div>;
}
function CodeDiffPreview() {
  return <div className="w-full h-full bg-[#0d1117] font-mono text-[11px] leading-relaxed overflow-hidden" data-id="element-257">
      <div className="bg-[#161b22] px-3 py-1.5 text-[10px] text-[#8a8680] flex justify-between border-b border-[#30363d]" data-id="element-258">
        <span data-id="element-259">src/components/ThemeToggle.tsx</span>
        <span data-id="element-260"><span className="text-[#7ee787]" data-id="element-261">+24</span> <span className="text-[#f47067]" data-id="element-262">-3</span></span>
      </div>
      <div className="text-[#7d8590] bg-[#161b22] px-3 py-0.5" data-id="element-263">@@ -1,8 +1,29 @@</div>
      <div className="px-3 text-[#8b949e]" data-id="element-264"> import React from 'react'</div>
      <div className="px-3 bg-[#12261e] text-[#7ee787]" data-id="element-265">+import {'{'} useTheme {'}'} from '../hooks/useTheme'</div>
      <div className="px-3 bg-[#12261e] text-[#7ee787]" data-id="element-266">+import {'{'} Moon, Sun {'}'} from 'lucide-react'</div>
      <div className="px-3 text-[#8b949e]" data-id="element-267"> </div>
      <div className="px-3 bg-[#2d1215] text-[#f47067]" data-id="element-268">-export function ThemeToggle() {'{'}</div>
      <div className="px-3 bg-[#12261e] text-[#7ee787]" data-id="element-269">+export function ThemeToggle() {'{'}</div>
      <div className="px-3 bg-[#12261e] text-[#7ee787]" data-id="element-270">+  const {'{'} theme, toggle {'}'} = useTheme()</div>
      <div className="px-3 bg-[#12261e] text-[#7ee787]" data-id="element-271">+  const icon = theme === 'dark'</div>
      <div className="px-3 bg-[#12261e] text-[#7ee787]" data-id="element-272">+    ? &lt;Sun size={'{16}'} /&gt;</div>
    </div>;
}
const PREVIEW_MAP: Record<string, React.FC> = {
  'screenshot': ScreenshotPreview,
  'video': VideoPreview,
  'preview-url': PreviewUrlPreview,
  'email-draft': EmailDraftPreview,
  'document': DocumentPreview,
  'code-diff': CodeDiffPreview
};
export function ArtifactPreview({
  artifact
}: {
  artifact: Artifact;
}) {
  const Preview = PREVIEW_MAP[artifact.type];
  return Preview ? <Preview data-id="element-273" /> : null;
}